import { LiveScoreBoard } from '@components/my-team/UIElements';
import { BodySmallRegular } from '@components/atoms/typography';

interface LiveRankTabProperties {
  lastFetchedTime: string;
  liveRankData: any;
  currentGameweek: number | null;
}

export const LiveRankTab = ({
  lastFetchedTime,
  liveRankData,
  currentGameweek
}: LiveRankTabProperties) => {
  return (
    <div>
      <div className="flex justify-center mt-2">
        <BodySmallRegular textColor="text-neutral-800">
          Last updated: {lastFetchedTime}
        </BodySmallRegular>
      </div>
      {liveRankData && (
        <LiveScoreBoard
          liveRankData={liveRankData}
          currentGameweek={currentGameweek}
        />
      )}
    </div>
  );
};
